module.exports = __webpack_public_path__ + "img/kv.6827d394.png";